import { render, staticRenderFns } from "./WidgetSelector.vue?vue&type=template&id=01cc8908&scoped=true"
import script from "./WidgetSelector.vue?vue&type=script&lang=js"
export * from "./WidgetSelector.vue?vue&type=script&lang=js"
import style0 from "./WidgetSelector.vue?vue&type=style&index=0&id=01cc8908&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01cc8908",
  null
  
)

export default component.exports